import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Button,
  Tooltip,
  IconButton,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { cellSX, layoutCSS } from "../component/common/commonStyle";
import dayjs from "dayjs";
import {
//   useGetApiSmsByPhoneSearchQuery,
//   useGetTodayApiSmsReportCSVMutation,
  useGetresellerapismsreportQuery,
} from "../store/services/reportApi";
import { useGetsmsapireportcountQuery } from "../store/services/smsApi";
import { useGetrcsresellerapireportQuery } from "../store/services/rcstemplateApi";
import { useNavigate } from "react-router-dom";

// ── Shared glass field style (matches the delivery report) ──
const inputSx = {
  borderRadius: "0.5rem",
  minWidth: 100,
  "& .MuiOutlinedInput-root": {
    background: "rgba(255,255,255,0.7)",
    "& fieldset": { borderColor: "#E2E8F0" },
    "&:hover fieldset": { borderColor: "#94A3B8" },
  },
  "& .MuiInputLabel-root": { color: "#475569" },
  "& .Mui-disabled": {
    "& .MuiOutlinedInput-input": {
      color: "#334155 !important",
      WebkitTextFillColor: "#334155 !important",
    },
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#CBD5E1" },
  },
};

const APIReport = () => {
  const navigate = useNavigate();
  const [serviceType, setServiceType] = useState("sms");
  const [startdate, setStartDate] = useState(dayjs());
  const [enddate, setEndDate] = useState(dayjs());
  const [phoneNumber, setPhoneNumber] = useState("");
  const [page, setPage] = useState(1);

  const [searchTrigger, setSearchTrigger] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [appliedPhoneNumber, setAppliedPhoneNumber] = useState("");

  const limit = 25;
  const formattedStartDate = startdate
    ? startdate.format("YYYY-MM-DD")
    : undefined;
  const formattedEndDate = enddate ? enddate.format("YYYY-MM-DD") : undefined;

  // const [downloadTodayReport] = useGetTodayApiSmsReportCSVMutation();

  // ── SMS list via reseller API (currentData, not data) ───────────────────
  const {
    currentData: smsSentReportData,
    isLoading: isSmsSentLoading,
    error: smsSentError,
    refetch: refetchSmsSentReport,
  } = useGetresellerapismsreportQuery(
    {
      startdate: formattedStartDate,
      enddate: formattedEndDate,
      page,
      limit,
    },
    {
      skip: serviceType !== "sms" || !!appliedPhoneNumber || !shouldFetch,
      refetchOnMountOrArgChange: false,
    }
  );

  const {
    currentData: rcsReportData,
    isLoading: isRcsReportLoading,
    error: rcsReportError,
  } = useGetrcsresellerapireportQuery(
    {
      startdate: formattedStartDate,
      enddate: formattedEndDate,
      page,
      limit,
    },
    {
      skip: serviceType !== "rcs" || !shouldFetch,
      refetchOnMountOrArgChange: false,
    }
  );

  // ── SMS summary ─────────────────────────────────────────────────────────
//   const {
//     data: smsSummaryData,
//     isLoading: smsSummaryLoading,
//     isError: smsSummaryError,
//   } = useGetsmsapireportcountQuery(
//     { startdate: formattedStartDate, enddate: formattedEndDate },
//     {
//       skip: !shouldFetch || !!appliedPhoneNumber,
//     }
//   );

  const isValidPhone =
    appliedPhoneNumber && appliedPhoneNumber.length === 10;

  // ── Phone‑number search ─────────────────────────────────────────────────
//   const {
//     data: searchData,
//     isLoading: isSearchLoading,
//     error: searchError,
//     refetch: refetchSearch,
//   } = useGetApiSmsByPhoneSearchQuery(appliedPhoneNumber, {
//     skip: !isValidPhone || !shouldFetch,
//   });

  const handleStartDateChange = (newValue) => {
    setStartDate(newValue);
    setShouldFetch(false);
    setSearchTrigger(false);
    if (enddate && newValue && enddate.diff(newValue, "month", true) > 1) {
      setEndDate(newValue.add(1, "month"));
    }
  };

  const handleEndDateChange = (newValue) => {
    setEndDate(newValue);
    setShouldFetch(false);
    setSearchTrigger(false);
  };

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) setPhoneNumber(value);
    setShouldFetch(false);
    setSearchTrigger(false);
  };

  const handleSearch = () => {
    setAppliedPhoneNumber(phoneNumber);
    setShouldFetch(true);
    setSearchTrigger(true);
    setPage(1);
  };

  const handleClearSearch = () => {
    setPhoneNumber("");
    setAppliedPhoneNumber("");
    setShouldFetch(false);
    setSearchTrigger(false);
    setPage(1);
  };

//   useEffect(() => {
//     if (searchTrigger && shouldFetch) {
//       if (appliedPhoneNumber && appliedPhoneNumber.length === 10) {
//         refetchSearch();
//       } else {
//         refetchSmsSentReport();
//       }
//       setSearchTrigger(false);
//     }
//   }, [
//     // searchTrigger,
//     // shouldFetch,
//     // appliedPhoneNumber,
//     // refetchSearch,
//     refetchSmsSentReport,
//   ]);

  useEffect(() => {
    setPage(1);
  }, [startdate, enddate]);

  const handlePageChange = (e, value) => {
    setPage(value);
    if (shouldFetch) {
      setSearchTrigger(true);
    }
  };

  const rows = serviceType === "sms" ? smsSentReportData?.data || [] : [];
  const rcsRows = serviceType === "rcs" ? rcsReportData?.data || [] : [];
  const isLoading =
    serviceType === "rcs" ? isRcsReportLoading : isSmsSentLoading;
  const error = serviceType === "rcs" ? rcsReportError : smsSentError;
  const headers =
    serviceType === "rcs"
      ? [
          "Sr No",
          "API Request ID",
          "Template Name",
          "Bot Name",
          "Total Numbers",
          "Created At",
          "Status",
          "RCS Overview",
          "Action",
        ]
      : [
          "Sr No",
          "Apireceive ID",
          "Template Name",
          "SenderID",
          "Total Numbers",
          "Created At",
          "Status",
          "SMS Overview",
          "Action",
        ];
  const totalPages =
    serviceType === "rcs"
      ? rcsReportData?.pagination?.totalPages
      : smsSentReportData?.pagination?.totalPages;

  const renderRcsOverview = (overview = {}) => (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      {["sent", "delivered", "read", "click", "failed"].map((status) => (
        <Box
          key={status}
          sx={{ display: "flex", alignItems: "center", gap: 0.75 }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              bgcolor: "#94a3b8",
              flexShrink: 0,
            }}
          />
          <Typography
            sx={{ fontSize: "0.72rem", color: "#475569", lineHeight: 1.3 }}
          >
            {status[0].toUpperCase() + status.slice(1)}:{" "}
            <Box component="span" sx={{ fontWeight: 600, color: "#0f172a" }}>
              {overview[status] ?? 0}
            </Box>
          </Typography>
        </Box>
      ))}
    </Box>
  );

  const renderSmsOverview = (ov = {}) => {
    const line = (label, value) => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <Box
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            bgcolor: "#94a3b8",
            flexShrink: 0,
          }}
        />
        <Typography
          sx={{ fontSize: "0.72rem", color: "#475569", lineHeight: 1.3 }}
        >
          {label}:{" "}
          <Box component="span" sx={{ fontWeight: 600, color: "#0f172a" }}>
            {value ?? 0}
          </Box>
        </Typography>
      </Box>
    );

    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
        {line("Sent", ov.sent)}
        {line("Delivered", ov.delivrd)}
        {line("Pending", ov.pending)}
        {line("Failed", ov.failed)}
        {line("Rejected", ov.rejected)}
      </Box>
    );
  };

  return (
    <Box sx={layoutCSS}>
      <Typography
        variant="h6"
        sx={{ mb: 1, fontSize: "0.9rem", fontWeight: "bold" }}
      >
        API Delivery Report
      </Typography>

      {/* filters bar */}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          flexWrap: "wrap",
          alignItems: "center",
          borderRadius: "0.5rem",
          padding: "1rem",
          backgroundColor: "#ffffff52",
          backdropFilter: "blur(10px)",
          boxShadow: "0 4px 12px rgba(14,165,233,0.1)",
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Start Date"
            value={startdate}
            onChange={handleStartDateChange}
            maxDate={dayjs()}
            format="DD/MM/YYYY"
            sx={{
              ...inputSx,
              width: 140,
            }}
            slotProps={{ textField: { size: "small" } }}
          />
          <DatePicker
            label="End Date"
            value={enddate}
            onChange={handleEndDateChange}
            maxDate={
              startdate
                ? startdate.add(1, "month").isBefore(dayjs())
                  ? startdate.add(1, "month")
                  : dayjs()
                : dayjs()
            }
            minDate={startdate}
            format="DD/MM/YYYY"
            sx={{
              ...inputSx,
              width: 140,
            }}
            slotProps={{ textField: { size: "small" } }}
          />
        </LocalizationProvider>

        <TextField
          select
          label="Report Type"
          value={serviceType}
          onChange={(event) => setServiceType(event.target.value)}
          size="small"
          sx={{ ...inputSx, width: 140 }}
        >
          {[
            ["sms", "SMS"],
            ["rcs", "RCS"],
            ["clicker", "Clicker"],
            ["whatsapp", "WhatsApp"],
          ].map(([value, label]) => (
            <MenuItem key={value} value={value} sx={{ fontSize: "0.75rem" }}>
              {label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label="Search Phone Number"
          value={phoneNumber}
          onChange={handlePhoneNumberChange}
          size="small"
          sx={{
            width: 150,
            "& .MuiInputBase-input": {
              fontSize: "0.75rem",
              padding: "6px 8px",
            },
            "& .MuiInputLabel-root": { fontSize: "0.75rem" },
          }}
        />

        <Button
          variant="contained"
          color="primary"
          onClick={handleSearch}
          sx={{ fontSize: "0.75rem", height: 35, minWidth: 80 }}
        >
          Search
        </Button>

        {appliedPhoneNumber && (
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleClearSearch}
            sx={{ fontSize: "0.75rem", height: 35, minWidth: 80 }}
          >
            Clear
          </Button>
        )}
      </Box>

      {/* ──────── SMS Status Summary ──────── */}
      {/* {!appliedPhoneNumber && shouldFetch && (
        <>
          {smsSummaryLoading ? (
            <Typography variant="body2" sx={{ fontSize: "0.75rem", mt: 0.5 }}>
              Loading summary…
            </Typography>
          ) : smsSummaryError || !smsSummaryData?.status ? (
            <Typography
              variant="body2"
              color="error"
              sx={{ fontSize: "0.75rem", mt: 0.5 }}
            >
              Failed to load summary
            </Typography>
          ) : (
            <Typography variant="body2" sx={{ fontSize: "0.75rem", mt: 0.5 }}>
              {smsSummaryData.data}
            </Typography>
          )}
        </>
      )} */}

      <TableContainer component={Paper} sx={{ mt: 3 }}>
        <Table>
          <TableHead
            sx={{
              bgcolor: "#0288d1",
              "& th": {
                color: "white",
                fontSize: "0.8rem",
                padding: "6px",
                borderBottom: "0.5px solid #1b1b1bff",
                borderRight: "0.5px solid #1b1b1bff",
                whiteSpace: "nowrap",
              },
            }}
          >
            <TableRow>
              {headers.map((header, index) => (
                <TableCell key={index}>{header}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {serviceType !== "sms" && serviceType !== "rcs" && (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  This report currently supports SMS and RCS only.
                </TableCell>
              </TableRow>
            )}

            {(serviceType === "sms" || serviceType === "rcs") &&
              isLoading &&
              shouldFetch && (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    Loading...
                  </TableCell>
                </TableRow>
              )}

            {(serviceType === "sms" || serviceType === "rcs") &&
              !isLoading &&
              error &&
              shouldFetch && (
                <TableRow>
                  <TableCell
                    colSpan={9}
                    align="center"
                    sx={{ color: "error.main" }}
                  >
                    Failed to load report data.
                  </TableCell>
                </TableRow>
              )}

            {serviceType === "sms" &&
              !isLoading &&
              !error &&
              rows.length > 0 &&
              rows.map((row) => (
                <TableRow
                  key={
                    row.apireceive_id || row.gateway_request_id || row.sr_no
                  }
                  hover
                  sx={{
                    "& td": { borderBottom: "0.5px solid #e2e8f0" },
                  }}
                >
                  <TableCell sx={{ ...cellSX, width: 70, maxWidth: 70 }}>
                    {row.sr_no}
                  </TableCell>

                  <TableCell sx={{ ...cellSX, width: 100, maxWidth: 100 }}>
                    {row.apireceive_id || "-"}
                  </TableCell>

                  <TableCell sx={{ ...cellSX, minWidth: 120 }}>
                    {row.template_name || "-"}
                  </TableCell>

                  <TableCell sx={{ ...cellSX, width: 100, maxWidth: 100 }}>
                    {row.sender_id || "-"}
                  </TableCell>

                  <TableCell sx={{ ...cellSX, width: 90, maxWidth: 90 }}>
                    {row.total_numbers ?? "-"}
                  </TableCell>

                  <TableCell sx={{ ...cellSX, width: 115, maxWidth: 115 }}>
                    {row.created_at ? (
                      <div>
                        <div>
                          {dayjs(row.created_at).format("DD/MM/YYYY")}
                        </div>
                        <div>{dayjs(row.created_at).format("HH:mm:ss")}</div>
                      </div>
                    ) : (
                      "-"
                    )}
                  </TableCell>

                  <TableCell sx={{ ...cellSX, width: 100, maxWidth: 100 }}>
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        color:
                          row.processed_status === "processed"
                            ? "#16a34a"
                            : row.processed_status === "failed"
                            ? "#dc2626"
                            : "#64748b",
                      }}
                    >
                      {row.processed_status || "-"}
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ ...cellSX, minWidth: 140 }}>
                    {renderSmsOverview(row.sms_overview)}
                  </TableCell>

                  <TableCell
                    sx={{ ...cellSX, width: 60, maxWidth: 60 }}
                    align="center"
                  >
                    <Tooltip title="View details">
                      <IconButton
                        size="small"
                        onClick={() =>
                          navigate("/api-sent-report", {
                            state: {
                              gatewayRequestId: row.gateway_request_id,
                            },
                          })
                        }
                      >
                        <MoreVertIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}

            {serviceType === "rcs" &&
              !isLoading &&
              !error &&
              rcsRows.length > 0 &&
              rcsRows.map((row) => (
                <TableRow
                  key={row.apirequest_id || row.apireceive_id || row.sr_no}
                  hover
                  sx={{
                    "& td": { borderBottom: "0.5px solid #e2e8f0" },
                  }}
                >
                  <TableCell sx={{ ...cellSX, width: 70, maxWidth: 70 }}>
                    {row.sr_no ?? "-"}
                  </TableCell>

                  <TableCell sx={{ ...cellSX, width: 120, maxWidth: 120 }}>
                    {row.apirequest_id || row.apireceive_id || "-"}
                  </TableCell>

                  <TableCell sx={{ ...cellSX, minWidth: 120 }}>
                    {row.template_name || "-"}
                  </TableCell>

                  <TableCell sx={{ ...cellSX, width: 100, maxWidth: 100 }}>
                    {row.bot_name || row.sender_id || "-"}
                  </TableCell>

                  <TableCell sx={{ ...cellSX, width: 90, maxWidth: 90 }}>
                    {row.total_numbers ?? "-"}
                  </TableCell>

                  <TableCell sx={{ ...cellSX, width: 115, maxWidth: 115 }}>
                    {row.created_at ? (
                      <div>
                        <div>{dayjs(row.created_at).format("DD/MM/YYYY")}</div>
                        <div>{dayjs(row.created_at).format("HH:mm:ss")}</div>
                      </div>
                    ) : (
                      "-"
                    )}
                  </TableCell>

                  <TableCell sx={{ ...cellSX, width: 100, maxWidth: 100 }}>
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        color:
                          row.processed_status === "processed" ||
                          row.processed_status === "EXECUTED"
                            ? "#16a34a"
                            : row.processed_status === "failed" ||
                              row.processed_status === "FAILED"
                            ? "#dc2626"
                            : "#64748b",
                      }}
                    >
                      {row.processed_status || row.status || "-"}
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ ...cellSX, minWidth: 140 }}>
                    {renderRcsOverview(row.rcs_overview)}
                  </TableCell>

                  <TableCell
                    sx={{ ...cellSX, width: 60, maxWidth: 60 }}
                    align="center"
                  >
                    <Tooltip title="View details">
                      <IconButton
                        size="small"
                        onClick={() =>
                          navigate("/api-sent-report", {
                            state: {
                              rcsRequestId:
                                row.apirequest_id || row.gateway_request_id,
                            },
                          })
                        }
                      >
                        <MoreVertIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}

            {serviceType === "sms" &&
              !isLoading &&
              !error &&
              rows.length === 0 &&
              shouldFetch && (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              )}

            {serviceType === "rcs" &&
              !isLoading &&
              !error &&
              rcsRows.length === 0 &&
              shouldFetch && (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              )}

            {(serviceType === "sms" || serviceType === "rcs") &&
              !shouldFetch && (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    Click Search to load data
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* ── Pagination ───────────────────────────────────────────────────── */}
      {(serviceType === "sms" || serviceType === "rcs") &&
        !(serviceType === "sms" && appliedPhoneNumber) &&
        totalPages > 1 &&
        shouldFetch && (
          <Box display="flex" justifyContent="center" mt={2}>
            <Pagination
              sx={{ fontSize: "0.7rem" }}
              count={totalPages || 1}
              page={page}
              onChange={handlePageChange}
              color="primary"
            />
          </Box>
        )}
    </Box>
  );
};

export default APIReport;